import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Container, Row, Col } from "react-bootstrap";
import skillsBG from "./img/skills.gif";
import './Skills.css';
import { SkillsCard } from "./SkillsCard";
import skillsData from "../../assets/data/skills.json"; //skills data

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" >
      <Container>
        <Row>
          <Col id="skills">
            <div className="skill-bx" style={{
              backgroundImage: `url(${skillsBG})`
            }}>
              <div className="skill-bg">
                <h2>
                  Skills
                </h2>
                <p>
                  Here are some of my top skills
                </p>
                <Carousel responsive={responsive} infinite={true} className="skill-slider">
                  {
                    skillsData.skills.map((skills, index) => {
                      return (
                        <SkillsCard key={index} {...skills} />
                      )
                    })
                  }

                </Carousel>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}